import { Cellstyle, ClickableCell } from "./cell";
import { HotDoc } from "./doc";

export class HotIconButton extends ClickableCell {

    onClickCallback: () => void;
    iconClass: string;

    constructor(flags?: Cellstyle, settings?: any) {
        super(flags, settings);
        this.stopImmediatePropagationActive = false;
    }

    onClick = (hotDoc: HotDoc): void => {
        if(this.onClickCallback) {
            setTimeout(() => {
                this.onClickCallback();
            }, 0);
        }
    };

    protected genHtml(): string {
        return `<button type="button" class="hot-icon-button">`+
            `<i class="${this.iconClass}"></i>`+
            `</button>`;
    }
}
